/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EListSearchType } from './EListSearchType';
import {
    EListSearchTypeFromJSON,
    EListSearchTypeFromJSONTyped,
    EListSearchTypeToJSON,
} from './EListSearchType';
import type { EStatutContrat } from './EStatutContrat';
import {
    EStatutContratFromJSON,
    EStatutContratFromJSONTyped,
    EStatutContratToJSON,
} from './EStatutContrat';

/**
 * 
 * @export
 * @interface EListSearchTypeEStatutContratCombinableCriteria
 */
export interface EListSearchTypeEStatutContratCombinableCriteria {
    /**
     * 
     * @type {EListSearchType}
     * @memberof EListSearchTypeEStatutContratCombinableCriteria
     */
    searchMode?: EListSearchType;
    /**
     * 
     * @type {EStatutContrat}
     * @memberof EListSearchTypeEStatutContratCombinableCriteria
     */
    value?: EStatutContrat;
    /**
     * 
     * @type {EStatutContrat}
     * @memberof EListSearchTypeEStatutContratCombinableCriteria
     */
    secondaryValue?: EStatutContrat;
}

/**
 * Check if a given object implements the EListSearchTypeEStatutContratCombinableCriteria interface.
 */
export function instanceOfEListSearchTypeEStatutContratCombinableCriteria(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EListSearchTypeEStatutContratCombinableCriteriaFromJSON(json: any): EListSearchTypeEStatutContratCombinableCriteria {
    return EListSearchTypeEStatutContratCombinableCriteriaFromJSONTyped(json, false);
}

export function EListSearchTypeEStatutContratCombinableCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): EListSearchTypeEStatutContratCombinableCriteria {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchMode': !exists(json, 'searchMode') ? undefined : EListSearchTypeFromJSON(json['searchMode']),
        'value': !exists(json, 'value') ? undefined : EStatutContratFromJSON(json['value']),
        'secondaryValue': !exists(json, 'secondaryValue') ? undefined : EStatutContratFromJSON(json['secondaryValue']),
    };
}

export function EListSearchTypeEStatutContratCombinableCriteriaToJSON(value?: EListSearchTypeEStatutContratCombinableCriteria | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'searchMode': EListSearchTypeToJSON(value.searchMode),
        'value': EStatutContratToJSON(value.value),
        'secondaryValue': EStatutContratToJSON(value.secondaryValue),
    };
}

